import { subscriptionPreOrderDeliveryProfileSettingsSchema } from "@redotech/redo-model/checkouts/subscription-pre-order-delivery-profile";
import * as z from "zod/v4";

export const updateSubscriptionPreOrderDeliveryProfileSettings = {
  name: "updateSubscriptionPreOrderDeliveryProfileSettings" as const,
  input: z.object({
    settings: subscriptionPreOrderDeliveryProfileSettingsSchema.omit({
      deliveryProfileId: true,
    }),
  }),
  output: z.null(),
};
